var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"cinlin"}},[_c('h1',[_vm._v(_vm._s(this.$options.name))]),_c('p',[_vm._v(" Search for backport commits in Linux kernel releases. ")]),_c('search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }